import { REWARDS } from '../actions/rewardsCampaigns';

const initialState = {
  items: [],
  totalCount: 0,
  pageNumber: 1,
  pageSize: 20,
  filters: {},
  listLoading: false,
  listLoaded: false,
  detail: null,
  detailLoading: false,
  detailLoaded: false,
  creating: false,
  createSuccess: false,
  createdCampaign: null,
  updatingStatus: false,
  error: null,
  message: null
};

export default (state = initialState, { type, ...payload }) => {
  switch (type) {
    case REWARDS.FETCH_LIST.LOAD:
      return {
        ...state,
        listLoading: true,
        listLoaded: false,
        filters: payload.filters || state.filters,
        error: null
      };

    case REWARDS.FETCH_LIST.SUCCESS:
      return {
        ...state,
        items: payload.items || [],
        totalCount: payload.totalCount || 0,
        pageNumber: payload.pageNumber || 1,
        pageSize: payload.pageSize || 20,
        listLoading: false,
        listLoaded: true
      };

    case REWARDS.FETCH_LIST.FAIL:
      return {
        ...state,
        listLoading: false,
        listLoaded: false,
        error: payload.error
      };

    case REWARDS.FETCH_DETAIL.LOAD:
      return {
        ...state,
        detail: null,
        detailLoading: true,
        detailLoaded: false,
        error: null
      };

    case REWARDS.FETCH_DETAIL.SUCCESS:
      return {
        ...state,
        detail: payload.detail,
        detailLoading: false,
        detailLoaded: true
      };

    case REWARDS.FETCH_DETAIL.FAIL:
      return {
        ...state,
        detailLoading: false,
        detailLoaded: false,
        error: payload.error
      };

    case REWARDS.CREATE.LOAD:
      return {
        ...state,
        creating: true,
        createSuccess: false,
        createdCampaign: null,
        error: null,
        message: null
      };

    case REWARDS.CREATE.SUCCESS:
      return {
        ...state,
        creating: false,
        createSuccess: true,
        createdCampaign: payload.campaign,
        message: 'Campaign created successfully'
      };

    case REWARDS.CREATE.FAIL:
      return {
        ...state,
        creating: false,
        createSuccess: false,
        error: payload.error,
        message: payload.message
      };

    case REWARDS.UPDATE_STATUS.LOAD:
      return {
        ...state,
        updatingStatus: true,
        error: null
      };

    case REWARDS.UPDATE_STATUS.SUCCESS:
      return {
        ...state,
        updatingStatus: false,
        detail: payload.detail || state.detail,
        message: payload.message || 'Status updated successfully'
      };

    case REWARDS.UPDATE_STATUS.FAIL:
      return {
        ...state,
        updatingStatus: false,
        error: payload.error,
        message: payload.message
      };

    case REWARDS.CLEAR_MESSAGE:
      return {
        ...state,
        message: null,
        error: null
      };

    case REWARDS.CLEAR_CREATE:
      return {
        ...state,
        createSuccess: false,
        createdCampaign: null,
        message: null,
        error: null
      };

    default:
      return state;
  }
};
